export const closes = (candles) => candles.map((c) => c.c);
export function sma(values, period) {
    return values.map((_, index) => {
        if (index + 1 < period)
            return Number.NaN;
        const slice = values.slice(index + 1 - period, index + 1);
        return slice.reduce((sum, value) => sum + value, 0) / period;
    });
}
export function ema(values, period) {
    const multiplier = 2 / (period + 1);
    const result = [];
    values.forEach((value, index) => {
        if (index === 0)
            result.push(value);
        else
            result.push(value * multiplier + result[index - 1] * (1 - multiplier));
    });
    return result;
}
export function rsi(values, period = 14) {
    const result = Array(values.length).fill(Number.NaN);
    for (let i = period; i < values.length; i += 1) {
        let gains = 0;
        let losses = 0;
        for (let j = i - period + 1; j <= i; j += 1) {
            const change = values[j] - values[j - 1];
            if (change >= 0)
                gains += change;
            else
                losses -= change;
        }
        const avgLoss = losses / period;
        const avgGain = gains / period;
        result[i] = avgLoss === 0 ? 100 : 100 - 100 / (1 + avgGain / avgLoss);
    }
    return result;
}
export function atr(candles, period = 14) {
    const tr = candles.map((candle, index) => {
        if (index === 0)
            return candle.h - candle.l;
        const previousClose = candles[index - 1].c;
        return Math.max(candle.h - candle.l, Math.abs(candle.h - previousClose), Math.abs(candle.l - previousClose));
    });
    return sma(tr, period);
}
export function bollinger(values, period = 20, deviation = 2) {
    const mid = sma(values, period);
    return values.map((_, index) => {
        if (index + 1 < period)
            return { middle: Number.NaN, upper: Number.NaN, lower: Number.NaN };
        const slice = values.slice(index + 1 - period, index + 1);
        const mean = mid[index];
        const variance = slice.reduce((sum, value) => sum + (value - mean) ** 2, 0) / period;
        const std = Math.sqrt(variance);
        return { middle: mean, upper: mean + std * deviation, lower: mean - std * deviation };
    });
}
